/***
 * Created on 2023/7/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import SwitchInput from "../common/form/switch_input";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {apiDelete, apiGet, apiPost, apiPut} from "../../service/api";
import InterestItem from "./interest_item";
import {useTranslation} from "react-i18next";
import ContentLoader from "../common/content_loader";
import {getErrorMessage} from 'common/ServiceCommon';
import {useBoundedStore} from 'common/Store';

const MY_INTERESTS_LIST = [
    {value: 1, 'image_file':'ic-cloud', display_text: 'my_interests_cloud'},
    {value: 2, 'image_file':'ic-collaboration', display_text: 'my_interests_for_business'},
    {value: 7, 'image_file':'ic-family-soho', display_text: 'my_interests_soho'},
    {value: 8, 'image_file':'ic-data-protection', display_text: 'my_interests_data_protection'},
    {value: 9, 'image_file':'ic-surveillance', display_text: 'my_interests_surveillance'},
    {value: 11, 'image_file':'ic-content-creation', display_text: 'my_interests_content_creation'},
    {value: 13, 'image_file':'ic-product-security', display_text: 'my_interests_product_security'},
    {value: 14, 'image_file':'ic-networking', display_text: 'my_interests_networking'},
    {value: 15, 'image_file':'ic-monthly-news', display_text: 'my_interests_monthly_news'}
]


function Subscription(props) {
    const queryClient = useQueryClient();
    const [enable, setEnable] = useState(false);
    const [subscribed, setSubscribed] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { t, i18n } = useTranslation();
    const store = useBoundedStore();

    const {data, isFetching, isSuccess, isError, error} = useQuery({
        queryKey: ['subscription'],
        queryFn: async () => {
            const data = await apiGet(`/ajax/subscribe/interests?t=${new Date().getTime()}`)
            setSubscribed(data.subscribed_ids);
            setIsLoading(false);
            return data;
        },
        retry: false
    });

    const subscribeMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/subscribe/interests', data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['subscription']
            })
            setEnable(true);
            setIsLoading(false);
        },
        onError: (error, variables, context) => {
            setIsLoading(false);
            store.globalAlert.setAlert(getErrorMessage(t, error.cause?.code), 'error', true);
        }
    });

    const subscribeUpdateMutation = useMutation({
        mutationFn: async (data) => await apiPut('/ajax/subscribe/interests', data),
        onSuccess: (data) => {
            setIsLoading(false);
        },
        onError: (error, variables, context) => {
            setIsLoading(false);
            store.globalAlert.setAlert(getErrorMessage(t, error.cause?.code), 'error', true);
        }
    });

    const deleteSubscribeMutation = useMutation({
        mutationFn: async () => await apiDelete('/ajax/subscribe/interests'),
        onSuccess: () => {
            queryClient.removeQueries(['subscription']);
            setSubscribed([]);
            setEnable(false);
            setIsLoading(false);

            // queryClient.invalidateQueries({
            //     queryKey: ['subscription']
            // }).then(success => {
            //     setSubscribed([]);
            //     setEnable(false);
            //     setIsLoading(false);
            // }, failed => {
            //     console.error(failed);
            // });
        },
        onError: (error, variables, context) => {
            setIsLoading(false);
            store.globalAlert.setAlert(getErrorMessage(t, error.cause?.code), 'error', true);
        }
    });

    const onSubmit = async () => {
        setIsLoading(true);
        const params = {category: subscribed.join(','), locale: i18n.language};
        if (params.category === "") {
            await deleteSubscribeMutation.mutateAsync();
        }
        else{
            await subscribeUpdateMutation.mutateAsync(params);
        }
    }

    const switchCallback = async (e, switch_value) => {
        setIsLoading(true);
        if (switch_value) {
            await subscribeMutation.mutateAsync({category: "13,15", locale: i18n.language});
        }
        else {
            await deleteSubscribeMutation.mutateAsync();
        }
    }

    useEffect(() => {
        if (data && data?.subscribed_ids?.length > 0) {
            setEnable(true);
        }
        else {
            setEnable(false);
            if (isError) {
                if (error?.message !== 'Not found' && error?.cause?.message !== 'Not found') {
                    store.globalAlert.setAlert(getErrorMessage(t, error.cause?.code), 'error', true);
                }
            }
        }
    }, [isSuccess, data?.subscribed_ids, isError]);

    return (
        <>
            {(isFetching || isLoading) && <ContentLoader />}
            {(!isFetching && !isLoading) &&
                <div className="page-content page-content--subscription">
                    <section className="subscription--ctrl">
                        <header>
                            <div className="mr-16">{t('@Subscribe@')}</div>
                            <SwitchInput value={enable} setValue={setEnable} callBack={switchCallback}/>
                        </header>
                    </section>
                    <div className="subscription--grid">
                        <div className={`subscriptions ${enable ? '' : 'lock'}`}>
                            {
                                MY_INTERESTS_LIST.map(item => (
                                    <InterestItem item={item} key={item.value}
                                                  subscribed={subscribed} setSubscribed={setSubscribed}/>
                                ))
                            }
                        </div>
                    </div>
                    <div className="subscription--action ">
                        <button type="button" className="q-btn q-btn--primary" onClick={onSubmit} disabled={!enable}>{t('@Save@')}</button>
                    </div>
                </div>
            }
        </>
    );
}

export default Subscription;